export default "__VITE_ASSET__xJlsVpMW__"